<template>
  <!-- システムタイトル -->
  <b-container class="container-div">
    <b-card class="toppage-wrap">
      <h2>　静岡県森林クラウド公開システム　</h2>
      <div class="version" v-show="showVersion">
        {{ constStore.clientVersion }}
        &nbsp;
        {{ constStore.envMode }}
      </div>
    </b-card>

    <div class="content-area">
      <!-- 左ペイン -->
      <div class="left-pane">
        <!-- 注意事項 -->
        <div class="license-frame">
          <div class="row justify-content-center">
            <div
              class="frame-title"
              style="padding-top: 1rem;"
            >
              静岡県森林クラウド公開システム
            </div>
            <div
              class="frame-title"
              style="padding-top: 1rem; padding-bottom: 2rem;"
            >
              御利用にあたっての注意事項
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="guideline">
              <p>
                森林簿及び森林計画図は、
                <span class="red-underline">
                  所有者権等土地に関する諸権利、所有界、面積及び木竹の評価等を証明するものではありません。
                </span>
              </p>
              <p style="margin-top: -15px;">
                なお、森林簿の情報は現況と異なる場合があります。
              </p>
              <p>
                本システムで公開しているデータは、静岡県が森林区域の資源管理などのために利用しているものあり、
                データの正確性、網羅性、特定の目的への適合性等について、静岡県は一切保証しません。
                本サイトの利用、あるいは利用できなかったことにより発生する直接又は間接の損害又は損失に対して、静岡県は一切の責任を負わないものとします。
              </p>
            </div>
          </div>
          <div class="row py-3 justify-content-center">
            <p>
            詳しくは、
            <a :href="documentRootInfo + '/Ryuuiten.html'" target="info">
              こちら
            </a>
            を御一読いただき、留意事項のすべてに同意される方は、次にお進みください。
            </p>
          </div>
          <b-form v-on:submit.prevent="agreeLicense()">
            <b-button
              type="submit"
              class="action-button"
              id="toppage-production"
              style="background: #ff7900; border-color: #ff7900; color: white;"
            >
              同意する
            </b-button>
          </b-form>
        </div>
      </div>

      <!-- 右ペイン -->
      <div class="right-pane">
          <!-- お知らせ -->
          <iframe
            class="infomation-iframe"
            :src="iInfoSource"
            frameborder="0"
          ></iframe>

          <!-- 関連リンク -->
          <div class="link-list">
            <div
              class="frame-title"
              style="padding: 1rem 0 1rem 0"
            >
              関連リンク
            </div>

            <div class="d-grid grid-template-columns">
              <div>
                <!-- 静岡県の森林と林業 -->
                <a
                  href="https://www.pref.shizuoka.jp/sangyoshigoto/ringyo/1003263/index.html"
                  target="_blank"
                >
                  <img class="link-img" :src="ringyouImgSrc" />
                </a>
              </div>

              <div>
                <!-- しずおか 木使い -->
                <a
                  href="https://www.pref.shizuoka.jp/kurashikankyo/kenchiku/kizukai/1054945/"
                  target="_blank"
                >
                  <img class="link-img" :src="kidukaiImgSrc" />
                </a>
              </div>

              <div>
                <!-- 静岡 森づくり情報 -->
                <a
                  href="https://www.pref.shizuoka.jp/kurashikankyo/shizenkankyo/morizukuri/"
                  target="_blank"
                >
                  <img class="link-img" :src="moridukuriImgSrc" />
                </a>
              </div>

              <div>
                <!-- 森林の土地所有者届出制度 対象森林の確認方法 -->
                <a
                  href="https://www.pref.shizuoka.jp/sangyoshigoto/ringyo/shinrinkeikaku/1026804.html"
                  target="_blank"
                >
                  <img class="link-img" :src="shinrinTodokedeImgSrc" />
                </a>
              </div>

              <div>
                <!-- Open Data Catalog Shizuoka -->
                <a href="https://opendata.pref.shizuoka.jp/" target="_blank">
                  <img class="link-img" :src="DataCatalogImgSrc" />
                </a>
              </div>
            </div><!-- class="d-grid grid-template-columns" -->
          </div><!-- class="link-list" -->
      </div>
    </div>

    <!-- フッター -->
    <div class="footer-area">
      <a
        :href="documentRootInfo + '/manual/manual.pdf'"
        class="footer-link"
        target="_blank"
        rel="noopener"
      >
        操作マニュアル
      </a>
      <span class="footer-separator">|</span>
      <a
        :href="documentRootInfo + '/manual/manual_simple.pdf'"
        class="footer-link"
        target="_blank"
        rel="noopener"
      >
        操作マニュアル(簡易版)
      </a>
      <span class="footer-separator">|</span>
      <a
        :href="documentRootInfo + '/Q&A.html'"
        class="footer-link"
        target="info"
      >
        よくある質問
      </a>
    </div>
  </b-container>
</template>

<script setup>
import { computed, onMounted, onUnmounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useConstStore, useAgreementStore } from "@/stores";

const route = useRoute();
const router = useRouter();
const constStore = useConstStore();
const agreementStore = useAgreementStore();

const iInfoSource = constStore.managementPath + "/information.html";
const moridukuriImgSrc = constStore.featureIconPath + "shizuoka-moridukuri.jpg";
const DataCatalogImgSrc = constStore.featureIconPath + "open-data-catalog-shizuoka.gif";
const shinrinTodokedeImgSrc = constStore.featureIconPath + "shinrin-tochishoyuushatodokedeseido.gif";
const kidukaiImgSrc = constStore.featureIconPath + "shizuoka-kidukai.jpg";
const ringyouImgSrc = constStore.featureIconPath + "shizuokaken-shinrin-ringyou.gif";

const documentRootInfo = computed(() => {
  return import.meta.env.VITE_DOCUMENT_ROOT_INFO;
});

const showVersion = computed(() => {
  const mode = constStore.envMode;
  return mode !== "";
});

onMounted(() => {
  console.log(`${constStore.clientVersion} ${constStore.envMode}`);
  document.documentElement.style.overflowY = 'auto';
  document.body.style.overflowY = 'auto';
});

onUnmounted(() => {
  document.documentElement.style.overflowY = '';
  document.body.style.overflowY = '';
});

function agreeLicense() {
  agreementStore.storeIsLicenseAgreed(true);

  const redirectUrl = route.query.redirect || '/';
  console.log(`redirectUrl=${redirectUrl}`);
  const version = route.query.version;
  console.log(`version=${version}`);
  router.push({ path: redirectUrl, query: { version: version }});
}
</script>

<style scoped>
.container {
  padding-left: 15px;
  padding-right: 15px;
}

.container-div {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 2em;
  max-width: 1100px !important;
  width: 100%;
}

.toppage-wrap {
  width: fit-content;
  margin: auto;
  border: 1px solid #00000020;
}

.version {
  text-align: center;
  font-size: 12px;
  color: gray;
}

.frame-title {
  font-size: 21px;
  font-weight: bold;
  text-align: center;
}

.license-frame {
  width: 510px;
  margin-top: 30px;
  height: calc(100vh - 272px);
  min-height: 370px;
  border: 1px solid #00000020;
  border-radius: 0.3rem;
  padding: 0.5rem 3rem;
}

.guideline {
  width: 400px;
  height: calc(100vh - 620px);
  max-height: 387px;
  border: 1px solid transparent;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 20px;
}

.infomation-iframe {
  margin-top: 30px;
  height: calc(100vh - 560px);
  min-height: 200px;
  border: 1px solid #00000020;
  border-radius: 0.3rem;
  padding: 0.5rem;
}

.action-button {
  border: 0px;
  width: 80%;
  height: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}

.grid-template-columns {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  justify-content: center;
}

.link-list {
  border: 1px solid #00000020;
  margin-top: 28px;
  height: 280px;
  padding: 0.5rem;
  border-radius: 0.3rem;
}

.link-img {
  width: 160px;
  height: 40px;
  margin-bottom: 24px;
}

a {
  color: blue;
  text-decoration: underline;
}

a:visited {
  color: blue;
}

a:hover {
  text-decoration: underline;
}

.footer-area {
  text-align: center;
  margin-top: 2rem;
  padding-bottom: 2rem;
}

.footer-link {
  color: blue;
  text-decoration: underline;
}

.footer-separator {
  margin: 0 0.5rem;
  color: #666;
}

.red-underline {
  color: red;
  text-decoration: underline;
}

.content-area {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 0 auto;
  gap: 40px;
}

.left-pane {
  display: flex;
  flex-direction: column;
}

.right-pane {
  display: flex;
  flex-direction: column;
  width: 510px;
}
</style>
